class ToTop {
  constructor() {
    this.items = document.querySelectorAll('.js-to-top');
    this.items.forEach(i => {
      i.addEventListener('click', (e) => {
        e.preventDefault();
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      })
    });
  }
} export default ToTop;